export default "__VITE_ASSET__DFL9CzTC__"